import { createStore } from 'vuex';
import router from './router';
import {saveGame, loadGame, deleteGame, loadAllGamesResult, loadScore} from './services/indexedDB';


let teamIdCounter = 1; // Counter to generate unique team IDs

export default createStore({
    state: {
        isLoggedIn: false, // Add isLoggedIn flag
        step: 'type',
        gameView: 'field',
        gameSettings: {
            mode: 'local',
            teamAName: '',
            teamBName: '',
            homeTeam: null,
            enforceGenderLimit: '1',
            maxPlayersPerGender: 4,
            type: 'single'
        },
        gameIsRunning: false,
        teams: [
            {
                id: teamIdCounter++,  // Unique ID for Team A
                name: '',
                players: [],
                teamSide: ''
            },
            {
                id: teamIdCounter++,  // Unique ID for Team B
                name: '',
                players: [],
                teamSide: ''
            },
        ],
        game: {
            id: 0,
            outs: 0,
            inning: 1,
            home: {
                team: "",
                score: 0,
                players: [
                ],
                lineUpPosition: 1,
            },
            guest: {
                team: "",
                score: 0,
                players: [
                ],
                lineUpPosition: 1,
            },
        },
        stats: [],
        score: {
            id: '',
            startTime: '',
            endTime: '',
            field: '',
            game: '',
            set: '',
            type: '',
            lineUpPosition: {
                home: 1,
                guest: 1,
            },
            officials: {
                homePlateOfficial: 'home',
                firstBaseOfficial: 'first',
                secondBaseOfficial: 'second',
                thirdBaseOfficial: 'third',
                tableOfficial: 'table',
            },
            info: {
                competition: 'competition',
                place: 'place',
                date: 'date',
                game: 'game',
                set: 'set',
            },
            inning: [],
        }
    },
    mutations: {
        SET_GAME_SETTINGS(state, settings) {
            state.gameSettings = settings;
            state.teams[0].name = settings.teamAName;
            state.teams[1].name = settings.teamBName;
        },
        SET_GAME_TYPE(state, type) {
            state.gameSettings.type = type;
        },
        SET_TEAMS(state, teams) {
            state.teams = teams;
        },
        ADD_PLAYER(state, { teamIndex, player }) {
            if (state.teams[teamIndex]) {
                state.teams[teamIndex].players.push({
                    ...player
                });
            }
        },
        DELETE_PLAYER(state, { teamIndex, playerId }) {
            const team = state.teams[teamIndex];
            if (team) {
                const playerIndex = team.players.findIndex(player => player.id === playerId);
                if (playerIndex > -1) {
                    team.players.splice(playerIndex, 1);
                }
            }
        },
        SET_GAME_IS_RUNNING(state, isRunning) {
            state.gameIsRunning = isRunning;
        },
        SET_GAME(state, game) {
            state.game = game;
        },
        RESET_GAME(state) {
            state.gameSettings = {
                mode: 'local',
                teamAName: '',
                teamBName: '',
                homeTeam: null,
                enforceGenderLimit: '1',
                maxPlayersPerGender: 4,
                type: 'single'
            };

            state.teams = [
                {
                    id: 1,
                    name: '',
                    players: [],
                },
                {
                    id: 2,
                    name: '',
                    players: [],
                },
            ];

            state.gameIsRunning = false;

            state.game = {
                id: 0,
                outs: 0,
                inning: 1,
                home: {
                    team: "",
                    score: 0,
                    players: [],
                    lineUpPosition: 1,
                },
                guest: {
                    team: "",
                    score: 0,
                    players: [],
                    lineUpPosition: 1,
                },
            };
            state.score = { 
                id: '',
                status: false,
                startTime: '',
                endTime: '',
                field: '',
                game: '',
                set: '',
                type: '',
                lineUpPosition: {
                    home: 1,
                    guest: 1,
                },
                officials: {
                    homePlateOfficial: 'home',
                    firstBaseOfficial: 'first',
                    secondBaseOfficial: 'second',
                    thirdBaseOfficial: 'third',
                    tableOfficial: 'table',
                },
                info: {
                    competition: 'competition',
                    place: 'place',
                    date: 'date',
                    game: 'game',
                    set: 'set',
                },
                inning: [],
            };

            state.stats = []; // Statistiken ebenfalls zurücksetzen
            state.step = 'type'; // Initiale Setup-Schritt-Anzeige zurücksetzen
        },
        SET_GAME_STATS(state, stats) {
            if (!state.stats) {
                state.stats = []; // Initialisiere das Array, falls nicht vorhanden
            }

            state.stats.push(stats);
        },
        SET_GAME_STATS_ALL(state, stats) {
            state.stats = stats;
        },
        SET_SCORE(state, score) {
            state.score = score;
        },
        clearStats(state) {
            state.stats = []; // Array leeren
        },
        SET_IS_LOGGED_IN(state, status) {
            state.isLoggedIn = status;
        },
        SET_STEP(state, step) {
            state.step = step
        },
        SET_GAME_VIEW(state, view) {
            state.gameView = view;
        },
        TOOGLE_GAME_VIEW(state) {
            state.gameView = state.gameView === 'field' ? 'scoreboard' : 'field';
        },
    },
    actions: {
        async loadLocalSettings({ commit, state }) {
            if (state.gameSettings.mode === 'local') {
                try {
                    const response = await fetch('/localGameSettings.json');
                    const data = await response.json();

                    commit('SET_GAME_SETTINGS', data.gameSettings);
                    commit('SET_TEAMS', data.teams);
                } catch (error) {
                    console.error("Error loading local settings:", error);
                }
            }
        },
        async checkSavedGames() {
            try {
                const savedGames = await loadAllGamesResult(); // Lädt alle gespeicherten Spiele
                if (Array.isArray(savedGames) && savedGames.length > 0) {
                    return true; // Spiele existieren
                } else {
                    console.warn('Keine gespeicherten Spiele vorhanden.');
                    return false; // Keine Spiele vorhanden
                }
            } catch (error) {
                console.error('Fehler beim Überprüfen der gespeicherten Spiele:', error);
                return false; // Fehlerbehandlung, falls etwas schiefgeht
            }

        },
        async resetPlay({ commit }, score) {
            const lastInning = JSON.parse(JSON.stringify(score.inning[0]));
            const lastPlay = lastInning.play?.[0];
            // const allPlays = score.inning.flatMap(i => i.play);
            //const lastLineUpPositionHome = score.inning.find(item => item.team === 'home')?.lineUpPosition;
            //const lastLineUpPositionGuest = score.inning.find(item => item.team === 'guest')?.lineUpPosition;
            commit('SET_SCORE', score); // Setze den Score
            const play = {
                id: score.id,
                outs: lastPlay.outs,
                inning: score.inning[0]?.inning,
                home: {
                    team: score.teams[1].name,
                    score: lastPlay.score.home,
                    players: lastPlay.positions.home,
                    lineUpPosition: lastPlay.lineUpPosition.home,
                },
                guest: {
                    team: score.teams[0].name,
                    score: lastPlay.score.guest,
                    players: lastPlay.positions.guest,
                    lineUpPosition: lastPlay.lineUpPosition.guest,

                },
                offenceTeam: lastPlay.offenceTeam,
            };
            commit('SET_GAME', play);
            commit('SET_TEAMS', score?.teams || []); // Teams setzen, wenn vorhanden
            return score
        },
        async continueGame({ dispatch }, id) {
            try {
                // console.log('continueGame', id);
                const game = await loadGame(id); // Lade das Spiel mit der gegebenen ID
                const score = await loadScore(id);
                if (!game) {
                    console.warn(`Spiel mit der ID ${id} existiert nicht mehr.`);
                    return false;
                }
                // Rufe die resetPlay-Action korrekt auf
                await dispatch('resetPlay', score.score);
        
                // Optional: Weitere Logik hier hinzufügen, falls nötig
                return true;
                // commit('SET_SCORE', score.score); // Setze den Score
                // const savedGames = game.game;
                // if (Array.isArray(savedGames) && savedGames.length > 0) {
                //     const previousPlay = savedGames[savedGames.length - 1]?.game; // Das letzte gespeicherte Spiel abrufen
                //     if (previousPlay) {
                //         commit('SET_GAME', previousPlay);
                //         commit('SET_TEAMS', savedGames[0]?.teams || []); // Teams setzen, wenn vorhanden
                //         commit('SET_GAME_STATS_ALL', JSON.parse(JSON.stringify(savedGames)));

                //         // Navigiere zur Game-Seite (wenn nicht bereits dort)
                //         if (router.currentRoute.value.path !== '/game') {
                //             router.push('/game');
                //         } else {
                //             return true
                //         }
                //     } else {
                //         console.warn('Kein gültiges Spiel im letzten Eintrag gefunden.');
                //     }
                // } else {
                //     console.warn(`Keine Spiele gefunden für die ID ${id}.`);
                // }
            } catch (error) {
                console.error(`Ein Fehler ist beim Laden des Spiels mit der ID ${id} aufgetreten:`, error);
                router.push('/'); // Rückfall bei Problemen
            }
        },
        async saveGame({ state }) {
            await saveGame(state.game);
        },
        async clearSavedGame() {
            await deleteGame();
        },
        resetGame ({ commit }) {
            commit('RESET_GAME');
        },

        setGameSettings({ commit }, settings) {
            commit('SET_GAME_SETTINGS', settings);
        },
        addPlayer({ commit }, payload) {
            commit('ADD_PLAYER', payload);
        },
        deletePlayer({ commit }, payload) {
            commit('DELETE_PLAYER', payload);
        },
        setGameIsRunning({ commit }, isRunning) {
            commit('SET_GAME_IS_RUNNING', isRunning);
        },
        setGame({ commit }, game) {
            commit('SET_GAME', game);
        },
        setTeams({ commit }, teams) {
            commit('SET_TEAMS', teams);
        },
        setGameStats({ commit }, stats) {
            commit('SET_GAME_STATS', stats);
        },
        setGameStatsAll({ commit }, stats) {
            commit('SET_GAME_STATS_ALL', stats);
        },
        resetStats({ commit }) {
            commit('clearStats'); // Stats zurücksetzen
        },
        async setScore({ commit }, score) {
            commit('SET_SCORE', score);
        },
        setGameType({ commit }, type) {
            commit('SET_GAME_TYPE', type);
        },
        setIsLoggedIn({ commit }, status) {
            commit('SET_IS_LOGGED_IN', status);
        },
        setStep({ commit }, step) {
            commit('SET_STEP', step);
        },
        setGameView({ commit }, view) {
            commit('SET_GAME_VIEW', view);
        }
    },
    getters: {
        teams: (state) => state.teams,
        gameSettings: (state) => state.gameSettings,
        getTeamById: (state) => (id) => {
            return state.teams.find(team => team.id === id);
        },
        getPlayerById: (state) => (playerId) => {
            for (const team of state.teams) {
                const player = team.players.find(player => player.id === playerId);
                if (player) {
                    return player; // Spieler gefunden
                }
            }
            return null; // Kein Spieler gefunden   
        },
        findPlayerInTeams: (state) => (playerId) => {
            for (const team of state.teams) {
                // Spieler innerhalb des Teams durchsuchen
                const player = team.players.find(player => player.id === playerId);
                if (player) {
                    return player; // Rückgabe des gefundenen Spielers
                }
            }
            return null; // Kein Spieler gefunden
        },
        findPlayerInScore: (state) => (playerId) => {
            for (const team of state.score.teams) {
                // Spieler innerhalb des Teams durchsuchen
                const player = team.players.find(player => player.id === playerId);
                if (player) {
                    return player; // Rückgabe des gefundenen Spielers
                }
            }
            return null; // Kein Spieler gefunden
        },
        findPrevPlayerInScore: (state) => (lineUpPos, team) => {
            const prevLineUpPosition = lineUpPos === 1 ? 5 : lineUpPos - 1;
            return JSON.parse(JSON.stringify(state.score.inning?.[0]?.play?.[0]?.positions[team].find(player => player.lineUpPosition === prevLineUpPosition))); // Kein Spieler gefunden
        },  
        findPlayerInGame: (state) => (playerId) => {
            // Spieler in "home.players" durchsuchen
            const homePlayer = state.game.home.players.find(player => player.id === playerId);
            if (homePlayer) {
                return homePlayer; // Spieler in "home.players" gefunden
            }

            // Spieler in "guest.players" durchsuchen
            const guestPlayer = state.game.guest.players.find(player => player.id === playerId);
            if (guestPlayer) {
                return guestPlayer; // Spieler in "guest.players" gefunden
            }

            return null; // Kein Spieler gefunden
        },
        getTeamByPlayer: (state) => (playerId) => {
            // Spieler in "home.players" durchsuchen
            const homePlayer = state.game.home.players.find(player => player.id === playerId);
            if (homePlayer) {
                return 'home'; // Spieler in "home.players" gefunden
            }

            // Spieler in "guest.players" durchsuchen
            const guestPlayer = state.game.guest.players.find(player => player.id === playerId);
            if (guestPlayer) {
                return 'guest'; // Spieler in "guest.players" gefunden
            }

            return null; // Kein Spieler gefunden
        },
        areGameSettingsComplete: (state) => {
            const { teamAName, teamBName, homeTeam } = state.gameSettings;
            return teamAName && teamBName && homeTeam;
        },
        getIsHomeOrGuestTeam: (state) => (teamName) => {
            if (teamName === state.game.homeTeam) {
                return 'home';
            } else if (teamName === state.teams.find(t => t.name !== state.game.homeTeam)?.name) {
                return 'guest';
            }
            return null; // In case the team doesn't match any
        },
        gameIsRunning: state => state.gameIsRunning,
        step: state => state.step,
        game: state => state.game,
        score: state => state.score,
        gameStats: state => state.stats,
        isLoggedIn: (state) => state.isLoggedIn,
        gameView: (state) => state.gameView,
    },
});
